import { AtomEffect } from 'recoil'
import { deepCopy, mergeObjects } from '../utils/misc.utils'
import queryParamsStorage from '../services/storages/queryParams.storage'
import { IQueryParamsSchema } from '../services/storages/queryParams.storage.types'

const generate =
  <T = any>(schema: IQueryParamsSchema): AtomEffect<T> =>
  ({ onSet, trigger, setSelf }) => {
    if (trigger === 'get') {
      setSelf((defaultValue) => {
        const resultingObject = deepCopy(defaultValue)
        const currentParams = queryParamsStorage.get(schema)

        mergeObjects(resultingObject, currentParams)

        return resultingObject as T
      })
    }

    onSet((updatedValue) => {
      queryParamsStorage.set(updatedValue, schema)
    })
  }

const recoilUrlSyncEffectGenerator = { generate }
export default recoilUrlSyncEffectGenerator
